/**
 * 기간 — 오늘까지 거슬러 올라가는 N일을 `yyyyMMdd` 두 수로.
 *
 * 미리보기·피벗·전체 내려받기가 **같은 기간**을 써야 숫자가 어긋나지 않아 한 자리에 둔다.
 */

import { toLocalPostDateInt } from 'src/utils/moments/moment-scope-values';

const DAY_MS = 24 * 60 * 60 * 1000;

/** @param now 기준 시각 — 테스트가 고정한다 */
export function toAnalyticsPeriod(days: number, now: number = Date.now()): { start: number; end: number } {
  const span = Math.max(1, Math.floor(days));
  return {
    start: toLocalPostDateInt(new Date(now - (span - 1) * DAY_MS)),
    end: toLocalPostDateInt(new Date(now)),
  };
}
